module.exports = __webpack_public_path__ + "static/blog37-20a41bbf179e93e3f93071a3ae396d19.png";